export const commitments = {
  state: {
    commitments: {
      sum_of_categories: {},
    },
    total: 0,
    youth_count: 0,
  },
  getters: {
    getCommitment:
      (state) =>
      (category = null, location = null) => {
        if (category === "all" && location === "Canada") {
          return state.total;
        }
        if (state.commitments.hasOwnProperty(category)) {
          if (state.commitments[category].hasOwnProperty(location))
            return state.commitments[category][location];
        }
        if (
          category === "all" &&
          state.commitments.sum_of_categories.hasOwnProperty(location)
        ) {
          return Number(state.commitments.sum_of_categories[location]);
        } else return 0;
      },
    getCategoryTotal: (state) => (category) => {
      if (state.commitments.hasOwnProperty(category)) {
        let total = 0;
        for (let key in state.commitments[category]) {
          total += Number(state.commitments[category][key]);
        }
        return total;
      } else return 0;
    },
    getCommitments: (state) => state.commitments,
    getTotal: (state) => state.total,
    getYouthCommitments: (state) => (location) => {
      let current_location = 0;
      if (state.commitments.hasOwnProperty("total_students_committing")) {
        current_location =
          state.commitments.total_students_committing.hasOwnProperty(location)
            ? state.commitments.total_students_committing[location]
            : 0;
        return location === "Canada" ? state.youth_count : current_location;
      }
    },
  },
  mutations: {
    setCommitments(state, commitments) {
      state.commitments = commitments;
    },
    setTotal(state, commitments) {
      for (let key in commitments.sum_of_categories) {
        state.total += Number(commitments.sum_of_categories[key]);
      }
    },
    setYouthCommitmentsTotal(state, commitments) {
      for (let key in commitments.total_students_committing) {
        state.youth_count += Number(commitments.total_students_committing[key]);
      }
    },
  },
  actions: {
    async fetchCommitments({ commit, state }) {
      if (state.total > 0) return;
      try {
        const responce = await fetch("/en/api/action_tracker");
        if (responce.ok) {
          const commitments = await responce.json();
          if (commitments.hasOwnProperty("total_students_committing")) {
            commit("setTotal", commitments);
            commit("setYouthCommitmentsTotal", commitments);
            commit("setCommitments", commitments);
          }
        }
      } catch (err) {
        console.log("failed to load commitments from server");
      }
    },
  },
};
